import type { TreeRecord } from './TreeItem'

export { calculateNewSortValue, getCreatedTime, getEffectiveSortValue, getSortValue } from '../shared/sortUtils'

import { getEffectiveSortValue } from '../shared/sortUtils'

/**
 * 二分查找插入位置（按有效排序值升序）
 */
export function binarySearchInsertIndex(nodes: TreeRecord[], effectiveSortValue: number, sortFieldId: string): number {
    let left = 0
    let right = nodes.length

    while (left < right) {
        const mid = Math.floor((left + right) / 2)
        const midValue = getEffectiveSortValue(nodes[mid].record, sortFieldId)

        if (effectiveSortValue < midValue) {
            right = mid
        } else {
            left = mid + 1
        }
    }

    return left
}
